'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _reactIntl = require('react-intl');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BidIncrements = require('./BidIncrements.scss');

var _BidIncrements2 = _interopRequireDefault(_BidIncrements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BidIncrements = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(BidIncrements, _Component);

    function BidIncrements() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BidIncrements);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BidIncrements.__proto__ || (0, _getPrototypeOf2.default)(BidIncrements)).call.apply(_ref, [this].concat(args))), _this), _this.mapBidIncrements = function (item, index) {
            return (0, _jsx3.default)('div', {
                className: _BidIncrements2.default.row
            }, index, (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                value: item.fromAmount,
                style: 'currency',
                currency: _this.props.currency
            }), (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                value: item.incAmount,
                style: 'currency',
                currency: _this.props.currency
            }));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(BidIncrements, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['currency', 'bidIncrements']);
        }
    }, {
        key: 'render',
        value: function render() {
            var bidIncrements = this.props.bidIncrements;


            return (0, _jsx3.default)('div', {
                className: _BidIncrements2.default.table
            }, void 0, (0, _jsx3.default)('div', {
                className: _BidIncrements2.default.row
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'price'
            }), (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'bid_increment'
            })), bidIncrements.map(this.mapBidIncrements));
        }
    }]);
    return BidIncrements;
}(_react.Component), _class.defaultProps = {
    bidIncrements: [],
    currency: 'usd'
}, _temp2);
exports.default = BidIncrements;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BidIncrements/BidIncrements.js
// module id = hXxF
// module chunks = 57